import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { FacilityAvailabilityTable } from "../../../components/facility-availability/FacilityAvailabilityTable";
import { useEffect } from "react";

const FacilityAvailability = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Facility Availability | Admin";
  }, []);

  const handleAddNew = () => {
    navigate("/admin/facility-availability/add");
  };

  return (
    <div id="facility_availability_page_container" className="space-y-6">
      <header className="space-y-4">
        <div>
          <h1 id="facility_availability_page_title" className="text-3xl font-bold text-foreground">Facility Availability</h1>
          <p className="text-muted-foreground">Manage facility availability</p>
        </div>
        <div className="flex justify-end">
          <Button id="facility_availability_page_add_btn" onClick={handleAddNew} className="bg-yellow-400 hover:bg-yellow-500 text-black">
            <Plus className="h-4 w-4" />
            Add New Facility Availability
          </Button>
        </div>
      </header>

      <main id="facility_availability_page_main">
        <FacilityAvailabilityTable />
      </main>
    </div>
  );
};

export default FacilityAvailability;
